import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
${ctx.showSwitcher ? html`
<div class="${ctx.loggedIn? 'logged-in': ''}">
  <small class="d-block font-size-small font-weight-bold">${until(ctx.__('<tt-a+2x/6rJ>', 'Switch Organization'))}</small>
  <ems-dropdown class="mr-0">
    <div class="d-flex align-items-center btn btn-outline-light " slot="dropdown-toggle">
      <span class="mr-2">${ctx.currentProfile.group_name}</span> <span class="d-none d-xs-block"></span>
      <span class="ai ai-chevron-down"></span>
    </div>
    <div id="flag-dd" slot="dropdown-menu" class="dropdown-menu m-0">
      ${Object.keys(ctx.orgs || {}).map((rootId) => html`
        <button class="${ctx['item-class']} btn dropdown-item" @click="${(e) => ctx.switchProfile(e, rootId)}" ?disabled="${rootId == ctx.currentProfile.root_id}">
          ${ctx.orgs[rootId]}
        </button>
      `)}
    </div>
  </ems-dropdown>
</div>
` : ''}
<template class="d-none dropdown-item menu-link btn btn-block text-left"></template>
`;
